import { Invoice } from "../models/Invoice";
import { InvoiceReportTemplateData } from "./InvoiceReportTemplateData";
import { InvoiceReportImportTemplate } from "./InvoiceReportImportTemplate";
import { cloneDeep } from "lodash";

export const getInvoiceReportTemplate = (
    reportData: Invoice,
) => {
return InvoiceReportImportTemplate(
    prepareData(reportData)
);
};

const prepareData = (reportData: Invoice) => {
const templateData: InvoiceReportTemplateData = {
    reportData: (cloneDeep(reportData))
};

return templateData;
};